import React from "react";
import "./card-history.css";
import TagLabelHistory from "../tagLabel/taglabelHistory";
import Button from "../button/button";

const Card = ({ label, labelB, tagType, tagTypeB, description, onClick, btnLabel, children , disabled}) => {
  let className = "card-history";

  return (
    <div className={className}>
      {label ? 
        <div className="tag-group">
          <TagLabelHistory label={label} variant={tagType} />
        </div>
        :
        ''
      }
      <div className="card-history-content">
        <p className="card-history-content_text" dangerouslySetInnerHTML={{__html: description}}/>
      </div>
      <div className="card-history-CTA">
        <Button
          label={btnLabel}
          variant="primary-alt"
          onClick={onClick}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default Card;
